// extracted by mini-css-extract-plugin
export default {"wrapper":"SetupIpaChannelsInfoCallout_wrapper__bjVEh","button":"SetupIpaChannelsInfoCallout_button__gqcTh"};